var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 5,
    viewBox: "0 0 290 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.699 3.08376C262.031 3.08376 234.376 2.88021 206.707 3.12447C147.472 3.66387 88.2506 4.51877 29.0157 4.99711C20.6171 5.06835 12.1923 3.80635 3.79376 3.02269C2.38091 2.90056 1.05964 2.08637 0 0.498693C1.34744 0.325677 2.68179 0 4.02923 0C49.9991 0.325677 95.969 0.895612 141.939 0.977032C171.334 1.02792 200.729 0.0712419 230.137 0.132306C250.087 0.173016 270.037 1.21111 290 1.8014C289.908 2.22885 289.817 2.6563 289.712 3.09393L289.699 3.08376Z",
    fill: "#83FBA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.0f4b824bcaa4367d7dbf24139810dd0c.svg";
export { ForwardRef as ReactComponent };